export const CELL_TYPES = [
  'None', 'Box', 'Fixed', 'Exit', 'Killer', 'SemiFixed', 'SemiKiller'
];